import {
  Box,
  Link as ChakraLink,
  ChakraProvider,
  extendTheme,
  Grid,
  HStack,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import React, { useEffect } from 'react'
import { FaBook, FaDiscord, FaGift, FaInstagram, FaPiggyBank, FaTelegram, FaTwitch } from 'react-icons/fa'
import 'tailwindcss/tailwind.css'

function App() {
  const links = [
    { url: 'https://donatello.to/zombif', icon: FaGift, text: 'Донат' },
    { url: 'https://send.monobank.ua/jar/28qKxHPHtE', icon: FaPiggyBank, text: 'Копілка (MonoBank)' },
    { url: 'https://t.me/zmb_zombi/3837', icon: FaBook, text: 'Правила' },
  ];

  const socialLinks = [
    { url: 'https://t.me/zmb_zombi', icon: FaTelegram },
    { url: 'https://discord.gg/yvPWQfQcBU', icon: FaDiscord },
    { url: 'https://www.twitch.tv/zmb_zombi', icon: FaTwitch },
  ];

  const theme = extendTheme({
    styles: {
      global: {
        body: {
          bg: 'url(./fon.png)',
          bgSize: 'cover',
          bgPosition: 'center',
          color: 'white',
          fontFamily: '"Montserrat", sans-serif',
        },
      },
    },
  });

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  const isMobile = window.innerWidth <= 768;

  const handleImageClick = () => {
    if (isMobile) onClose();
  };

  return (
    <ChakraProvider theme={theme}>
      <Box textAlign="center" fontSize="xl">
        <Grid minH="100vh" p={4}>
          <VStack marginTop="1em" spacing={4}>
            <Image
              src="./Logo.jpg"
              alt="Avatar"
              w={{ base: '12em', md: '18em' }}
              borderRadius="full"
              boxShadow="0px 0px 20px rgba(107, 255, 87, 0.8)"
            />
            <Text
              fontSize={{ base: 24, md: 32 }}
              fontWeight="bold"
              color="white"
              textShadow="0px 0px 15px rgba(0, 0, 0, 0.7)"
              marginBottom="0.5em"
            >
              @Zombif
            </Text>
          </VStack>

          <HStack spacing={4} justifyContent="center" mt={1}>
            {socialLinks.map((link, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
              >
                <ChakraLink href={link.url} target="_blank">
                  <IconButton
                    bg="rgba(0, 0, 0, 0.5)"
                    color="white"
                    icon={React.createElement(link.icon, { size: 24 })}
                    _hover={{
                      transform: 'scale(1.1)',
                      boxShadow: '0px 8px 15px',
                    }}
                    w="4em"
                    h="4em"
                    borderRadius="12px"
                    transition="all 0.3s ease"
                  />
                </ChakraLink>
              </motion.div>
            ))}
          </HStack>

          <VStack spacing={4} mt={4} px={2}>
            {links.map((link) => (
              <ChakraLink
                href={link.url}
                target="_blank"
                key={link.text}
                _hover={{ textDecoration: 'none' }}
              >
                <HStack
                  w={{ base: '14em', md: '18em' }}
                  h={{ base: '3.5em', md: '4em' }}
                  borderRadius="12px"
                  bg="rgba(0, 0, 0, 0.5)"
                  p="0.8em"
                  color="white"
                  _hover={{
                    transform: 'scale(1.05)',
                    boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.6)',
                  }}
                  transition="all 0.3s ease"
                >
                  <Text as={link.icon} fontSize={{ base: 20, md: 28 }} />
                  <Text fontSize={{ base: 16, md: 20 }} fontWeight="bold">
                    {link.text}
                  </Text>
                </HStack>
              </ChakraLink>
            ))}
          </VStack>

          <Box
            bg="rgba(0, 0, 0, 0.7)" // Напівпрозорий фон
            color="white"
            p={4}
            borderRadius="12px"
            mt={8}
            textAlign="center"
            h={{ base: 'auto', md: '3em' }}
            w={{ base: '90%', md: '50%' }}
            mx="auto"
          >
            Якщо хочеш попасти до челенджу заходь до телеграму. Дякую всім хто купує з кодом автора ZOMBIF – Ви НАЙКРАЩІ
          </Box>

          {!isMobile && (
            <Box
              position="fixed"
              bottom="2em"
              left="2em"
              zIndex="10"
              className="animate-bounce"
            >
              <HStack
                as="button"
                onClick={onOpen}
                w="5.1em"
                h="2em"
                borderRadius="10px"
                bg="rgba(0, 0, 0, 0.8)"
                p="0.7em"
                color="white"
                fontSize="1.2em"
                _hover={{
                  transform: 'scale(1.1)',
                  boxShadow: '0px 8px 15px rgba(255, 0, 0, 0.8)',
                }}
                transition="all 0.3s ease"
              >
                <Text fontSize={{ md: 16 }} fontWeight="bold">
                  Тег автора
                </Text>
              </HStack>
            </Box>
          )}

          <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
            <ModalOverlay />
            <ModalContent
              bg="transparent"
              boxShadow="none"
              display="flex"
              justifyContent="center"
              alignItems="center"
              onClick={handleImageClick}
            >
              <ModalBody>
                <Image src="./teg.jpg" alt="Author Tag" w="100%" borderRadius={'12px'} />
              </ModalBody>
            </ModalContent>
          </Modal>
        </Grid>
      </Box>
    </ChakraProvider>
  );
}

export default App;
